import * as React from 'react';
import { SeatStyle } from '../../classes/seat';


export interface ISeatInfoHeaderProps {
    seatDescription: string;
    seatRowNumber: string;
    svgStrokeColor: string;
    seatStyleSvgPath: string;
    svgViewBox: string;
    svgDefaultFill: string;
    svgStrokeWidth: number;
    fullPrompt: string;
}

class SeatInfoHeader extends React.PureComponent<ISeatInfoHeaderProps, any>{


    render() {
        const { svgStrokeColor, seatStyleSvgPath, svgViewBox, svgDefaultFill, svgStrokeWidth } = this.props;
        const errorSvg = '<use xlink:href="#icon-alert" />';

        const hasSeatStyle = seatStyleSvgPath != null && seatStyleSvgPath.length > 0;

        return (
            <div className="seat-info-header">
                <div className="seat-info-header-item">
                    <svg className="seat-info-header-icon" viewBox={hasSeatStyle ? svgViewBox : "0 0 30 30"}>
                        {hasSeatStyle ?
                            <path d={seatStyleSvgPath}
                                fill={svgDefaultFill}
                                stroke={svgStrokeColor}
                                strokeWidth={svgStrokeWidth}></path>
                            :
                            <circle r="15" cx="15" cy="15" fill={svgDefaultFill}
                                stroke={svgStrokeColor}
                                strokeWidth={svgStrokeWidth}></circle>
                        }
                    </svg>
                    <div className="seat-info-header-item-content">
                        <span className="seat-description">{this.props.seatDescription}</span>
                        {this.props.seatRowNumber != null ?
                            <span className="seat-info caption-paragraph">{this.props.seatRowNumber}</span>
                            : null
                        }
                    </div>
                </div>

                {
                    this.props.fullPrompt ?
                        <div className="seat-info-header-item notice">
                            <svg className="seat-info-header-icon" dangerouslySetInnerHTML={{ __html: errorSvg }} />
                            <div className="seat-info-header-item-content">
                                <span className="caption-paragraph" dangerouslySetInnerHTML={{ __html: this.props.fullPrompt }} />
                            </div>
                        </div>

                        : null
                }

            </div>
        );
    }
}

export default SeatInfoHeader;